<template>
  <div>
    <v-row>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
        <story-registered/>
      </v-col>
      <v-col
          :class="$vuetify.breakpoint.mdAndUp ? '': 'vertical-cols-margin'"
          :cols="$vuetify.breakpoint.mdAndUp ? 8 : 12">
        <story-form/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StoryForm from "../components/Story/StoryForm";
import StoriesRegistered from "../components/Story/StoryRegistered";

export default {
  name: "RegisterStory",
  components: {
    'story-form': StoryForm,
    'story-registered': StoriesRegistered
  }
}
</script>

<style scoped>

</style>